function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "77250955-29B8-44C2-A4E2-C343D009FB4C");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Predict-Important-Motifs",
  transform: "translate(-860.000000, -94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_1",
  transform: "translate(860.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-4\\u5907\\u4EFD"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#008E8E",
  x: 0.967741935,
  y: 0,
  width: 58.0645161,
  height: 42.5806452,
  rx: 19.3548387
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  transform: "translate(13.548387, 7.319962)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.516129,29.0322581 L44.516129,50.3225806 C53.5483871,39.1542004 58.0645161,32.0574263 58.0645161,29.0322581 C58.0645161,26.0070899 53.5483871,26.0070899 44.516129,29.0322581 Z",
  id: "\\u8DEF\\u5F84-2",
  fill: "#008E8E"
})), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#FFFFFF",
  x: 15,
  y: 20.625,
  width: 5.625,
  height: 13.125,
  rx: 1.875
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62\\u5907\\u4EFD-4",
  fill: "#FFFFFF",
  x: 26.25,
  y: 9.375,
  width: 5.625,
  height: 24.375,
  rx: 1.875
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
  fill: "#FFFFFF",
  x: 37.5,
  y: 16.875,
  width: 5.625,
  height: 16.875,
  rx: 1.875
}))));

const SvgIcImportantMotifs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "60px",
  height: "51px",
  viewBox: "0 0 60 51",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImportantMotifs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-important-motifs.0af8b212.svg";
export { ForwardRef as ReactComponent };